import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { JETSTREAM_SERVER_US } from '~/app/models/constans';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	JetStreamServerUrl: JETSTREAM_SERVER_US,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	useStaticPriceDateRemark: true,
	hideConsumptionEmissionEngineName: true,
	enablePartsRateCalculation: true,
	enableFinancingServices: false,
	hideMonthlyRates: true,
	financeDomain: 'AUDI.CC.TW',
};
